import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
/**
 * * 운영-출석- 데이 리스트
 */
const DayListComponent = () => {
  const { t } = useTranslation();
  return (
    <Table>
      <thead>
        <tr>
          <th>{t('attendanceID.dayList.day')}</th>
          <th>{t('attendanceID.dayList.type')}</th>
          <th>{t('attendanceID.dayList.quality')}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </Table>
  );
};

export default DayListComponent;

const Table = styled.table``;
